// Filter dropdown options, DERIVED FROM THE LOADED ROWS.
//
// ⚠️ A HARDCODED OPTION LIST GOES STALE IN THE SILENT DIRECTION, and this
// project has already paid for it once: /catalog's brand filter was a literal
// array that omitted "Poly", so the only real product in the catalog could
// not be filtered to. Nothing errored. The list simply never offered the
// value, and the row it would have matched looked like it did not exist.
//
// The rule, which /inventory and /catalog already follow and which this
// helper exists so the reference-data screens can follow too:
//
//   * options come from the rows on screen, never from a literal;
//   * a control whose derived set is EMPTY is HIDDEN rather than rendered
//     with only "All" in it -- an empty dropdown invites a click that can
//     change nothing;
//   * a value the current rows do not contain is not offered, because
//     selecting it could only ever produce an empty table.
//
// It does NOT sort by frequency or recency. Alphabetical is the order
// somebody scanning a list expects, and a list that reorders itself as data
// changes is harder to use than one that does not.

/** The distinct, non-empty values of one field across the loaded rows,
 *  sorted. Nulls and blanks are dropped rather than offered as a filter
 *  option: "not recorded" is a real state of a row, but it is not something
 *  anyone means to filter FOR, and rendering it as an empty <option> is
 *  indistinguishable from a broken list. */
export function derivedOptions<T>(
  rows: readonly T[],
  pick: (row: T) => string | null | undefined,
): string[] {
  const seen = new Set<string>();
  for (const row of rows) {
    const value = pick(row);
    if (value) seen.add(value);
  }
  return Array.from(seen).sort((a, b) => a.localeCompare(b));
}
